import React, { useState, useEffect } from "react";
import { Checkbox, Divider } from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";
import EditUnitNew from "Screens/Design/Unit/components/DesignMain/components/EditUnitNew";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { updateUnitsOrder } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { DESIGN_UNIT_LIST } from "Stores/actionTypes";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import Translator from "Languages/Utility/Translator";

export default function UnitShowMode({
  data,
  selectedUnitId,
  onSelectedChanged,
  currentPage,
  loading,
  setLoading,
  openNewUnit,
  getUnitData,
  setUnitData,
  mode,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [localData, setLocalData] = useState([]);

  const { unitListPagination } = useSelector((state) => ({
    unitListPagination: state.design.unitListPagination,
  }));

  useEffect(() => {
    const sortedData = [...data].sort((a, b) => a.Order - b.Order);
    setLocalData(sortedData);
  }, [data]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;
    const items = Array.from(localData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const updatedItems = items.map((item, index) => ({
      ...item,
      Order: index + 1,
    }));
    const sortedItems = updatedItems.sort((a, b) => a.Order - b.Order);
    setLocalData(sortedItems);
    submit_order_change(sortedItems);
    setData(sortedItems);
  };

  const submit_order_change = async (sortedItems) => {
    setLoading(true);
    const newOrder = sortedItems.map((item) => {
      return { Id: item.Id, Order: item.Order };
    });
    await dispatch(
      updateUnitsOrder({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        array: newOrder,
      })
    );
    setLoading(false);
  };

  const setData = async (sortedItems) => {
    await dispatch({
      type: DESIGN_UNIT_LIST,
      unitList: sortedItems,
      unitListPagination: unitListPagination,
    });
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="unitList">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="units-list-body"
          >
            {localData.map((item, index) => (
              <Draggable
                key={item.Id}
                draggableId={item.Id.toString()}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    className={`each-unit ${
                      selectedUnitId === item.Id ? "active" : ""
                    } ${snapshot.isDragging ? "unit-draged" : ""}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <div className="each-options">
                      <div className="select">
                        {!item.Islock ? (
                          <>
                            <Checkbox
                              checked={item.IsSelect}
                              onClick={() => onSelectedChanged(item)}
                              id={`select-unit-${item.Id}`}
                            />
                            <label htmlFor={`select-unit-${item.Id}`}>
                              {item.Name}
                            </label>
                          </>
                        ) : (
                          <Icons.LockFill size={18} />
                        )}
                      </div>
                      <div className="buttons">
                        <EditUnitNew
                          unit={item}
                          getUnitData={getUnitData}
                          setUnitData={setUnitData}
                        />
                        <MuiIconButton
                          title={<Translator id={"unitReorder"} />}
                          icon={<Icons.ArrowsExpand />}
                          className="button-change-order"
                          {...provided.dragHandleProps}
                        />
                      </div>
                    </div>
                    <div
                      className={`each-unit-show ${
                        mode === 1 ? "column-mode" : "row-mode"
                      }`}
                    >
                      <div className="each-unit-details">
                        <span>
                          {item.HUnit}
                          <Icons.X className="x-in-size" />
                          {item.WUnit}
                        </span>
                        <Divider
                          className="details-divider"
                          orientation="vertical"
                          flexItem
                        />
                        <span>{`${item.CountUnit} ${t("_count")}`}</span>
                      </div>
                      <div
                        className="each-unit-image"
                        onClick={() => openNewUnit(item.Id)}
                      >
                        <img
                          src={`data:image/png;base64, ${item.Image}`}
                          alt={item.Name}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
